import { postData } from '../utils/ajax-utils';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare const script_var: any;

export default function initProfileInfoForm() {
    const $ProfileInfoFormContainer = document.querySelectorAll<HTMLFormElement>('.js-form-profile-info');
    $ProfileInfoFormContainer.forEach($container => {
        new ProfileInfoForm($container);
    });
}

export class ProfileInfoForm {
    $container: HTMLFormElement;
    $form: HTMLFormElement | null;
    $initialFormState: Map<string, string>;
    $submitButton: HTMLButtonElement | null;
    $editionButton: HTMLButtonElement | null;
    constructor($container: HTMLFormElement) {
        this.$container = $container;
        this.$form = this.$container.querySelector('form');
        this.$initialFormState = new Map();
        this.$submitButton = this.$container.querySelector<HTMLButtonElement>('button[type="submit"]');
        this.$editionButton = this.$container.querySelector<HTMLButtonElement>('.js-btn-edition');
        this.init();
    }

    init(): void {
        this.storeInitialFormState();
        this.updateSubmitButtonState();

        this.$editionButton?.addEventListener('click', () => {
            this.toggleFormEdition();
        });

        this.$form?.addEventListener('input', () => {
            this.updateSubmitButtonState();
        });

        // Lorsqu'on submit le formulaire
        this.$form?.addEventListener('submit', evt => {
            evt.preventDefault();
            
            if (this.hasFormChanged()) {
                this.$form?.classList.add('loading');
                
                const formDataValidation = new URLSearchParams();
                formDataValidation.append('action', 'submit_profile_info_form');
            
                if (this.$form) {
                    for (const pair of new FormData(this.$form)) {
                        formDataValidation.append(pair[0], pair[1] as string);
                    }
                }

                // Validation ajax
                postData(script_var.ajax_url, formDataValidation).then(response => {
                    if (!response.success) {
                        this.$form?.classList.remove('loading');
                        this.resetErrors();
                        const errors = response.data.errors;
                        for (const key in errors) {
                            if (Object.prototype.hasOwnProperty.call(errors, key)) { // Vérifie que la clé appartient bien à l'objet
                                const value = errors[key];
                                if (Array.isArray(value)) {
                                    value.forEach(() => {
                                        const fields = this.$form?.querySelectorAll(`[name="form_profile_info[${key}]"]:not([disabled])`);
                                        if (fields) {
                                            fields.forEach((field, index) => {
                                                const errorField = field.closest('.form-col')?.querySelector('.form-error[role="alert"]') as HTMLElement;
                                                
                                                if (errorField && value[index]) {
                                                    this.displayError(errorField, value[index]);
                                                }
                                            });
                                        }
                                    });
                                } else {
                                    const field = this.$form?.querySelector('[name=form_profile_info\\[' + key + '\\]]');
                                    if (field) {
                                        const errorField = field.closest('.form-col')?.querySelector('.form-error[role="alert"]') as HTMLElement;
                                        this.displayError(errorField, value);
                                    }
                                }
                            }
                        }
                        
                        const navHeight = document.getElementById('main-header')?.offsetHeight;
                        const elements = document.querySelectorAll('div.form-error');
                        const firstError = Array.from(elements).find(element => element.textContent?.trim() !== '') as HTMLElement;
                        const firstErrorParent = firstError?.parentElement;
                        
                        if (navHeight && firstErrorParent) {
                            window.scrollTo({
                                behavior: 'smooth',
                                left: 0,
                                top: firstErrorParent.offsetTop - navHeight - 20,
                            });
                        }
                    } else {
                        // this.init();
                        this.toggleFormEdition();

                    }
                    
                    this.$form?.classList.remove('loading');
                });
            }
        });
    }

    storeInitialFormState(): void {
        if (this.$form) {
            for (const pair of new FormData(this.$form)) {
                this.$initialFormState.set(pair[0], pair[1] as string);
            }
        }
    }

    hasFormChanged(): boolean {
        if (this.$form) {
            for (const pair of new FormData(this.$form)) {
                const fieldName = pair[0];
                const fieldValue = pair[1] as string;

                if (this.$initialFormState.get(fieldName) !== fieldValue) {
                    return true;
                }
            }
        }
        return false;
    }

    updateSubmitButtonState(): void {
        if (this.$submitButton) {
            this.$submitButton.disabled = !this.hasFormChanged();
        }
    }

    displayError(fieldError: HTMLElement, errorMessage: string): void
    {
        const $errorContainer = fieldError;

        if ($errorContainer) {
            $errorContainer.innerText = errorMessage;
        }
    }

    resetErrors(): void {
        this.$form?.querySelectorAll<HTMLElement>('.form-error[role="alert"]').forEach($errorContainer => $errorContainer.innerText = '');
    }

    toggleFormEdition(): void {
        this.$container?.classList.toggle('editing');
        this.$form?.querySelectorAll<HTMLInputElement>('input').forEach($input => $input.readOnly = !this.$container?.classList.contains('editing'));
        this.$form?.querySelectorAll<HTMLSelectElement>('select').forEach($select => $select.disabled = !this.$container?.classList.contains('editing'));
        this.resetErrors()
    }
}
